import { useTranslation } from 'react-i18next';
import CategoryGrid from '@/components/feature/CategoryGrid';

export default function CategorySection() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-20">
      <div className="text-center">
        <h2 className="font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
          {t('home.categories.title')}
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
          {t('home.categories.subtitle')}
        </p>
      </div>
      <div className="mt-10">
        <CategoryGrid />
      </div>
    </section>
  );
}